import { Pricing } from "src/app/ui/models/domains/pbm/product-management/pricing";
import { AbstractParser } from "../../parser";
import { parseProductPricings } from "./product-management-parse-funtions";

export class ProductPricingsParser extends AbstractParser<Pricing[]> {
  public parse(payload: any): Pricing[] {
    const pricings = payload.Pricings;
    return parseProductPricings(pricings);
  }
}
